/// <amd-module name="Widgets/Burndown/BurndownWidgetComponents/BurndownActionCreator" />
import { ActionCreatorBase } from "WidgetCommon/ModernWidgetTypes/ActionCreatorBase";

export class BurndownActionCreator extends ActionCreatorBase {}
